import { isDevelopmentMode, sendRequest } from "../base";

export const getUserBalance = (commodity_id = 1) => {
  return sendRequest(
    isDevelopmentMode()
      ? `/wallets/transactions/assets?commodity_id=${commodity_id}`
      : "/balance/gold/"
  );
};
